<div [ngClass]="inColumn ? 'received-lab-list-column' : 'received-lab-list-row'">
  <span *ngIf="showTitle">Muestras:</span>
  <mat-spinner [diameter]="50" *ngIf="loading"></mat-spinner>
  <div *ngFor="let item of items" class="cell-date">

      <mat-checkbox
        [disabled]="updating"
        [(ngModel)]="item.Received"
        (ngModelChange)="update()"
        >{{ item.ProcedureName }}</mat-checkbox
      >

  </div>
</div>
